var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"container--fluid fill-height"},[_c('v-row',{attrs:{"align":"center","dense":"","justify":"center","no-gutters":""}},[_c('v-col',{staticClass:"text-center"},[_vm._t("page")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }